/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KeyUpdateChallengeResponse } from '../models/KeyUpdateChallengeResponse';
import type { KeyUpdateRequest } from '../models/KeyUpdateRequest';
import type { KeyUpdateResponse } from '../models/KeyUpdateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileKeyUpdateService {
    /**
     * Issue a device key-update challenge
     * Mint a single-use challenge the device signs with its device-bound key. Requires an authenticated mobile session.
     * @param xMobileAuth
     * @returns KeyUpdateChallengeResponse Successful Response
     * @throws ApiError
     */
    public static startKeyUpdateChallenge(
        xMobileAuth?: (string | null),
    ): CancelablePromise<KeyUpdateChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v2/auth/key-update/challenge',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Register or replace a device key
     * Register or replace the device's biometric public key, proving possession of the device-bound key by signing the issued challenge.
     * @param requestBody
     * @param xMobileAuth
     * @returns KeyUpdateResponse Successful Response
     * @throws ApiError
     */
    public static applyKeyUpdate(
        requestBody: KeyUpdateRequest,
        xMobileAuth?: (string | null),
    ): CancelablePromise<KeyUpdateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v2/auth/key-update',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
